import StatusBarMobile from './StatusBarMobile';

export default StatusBarMobile;
